import { apiClient } from "./apiClient";

export const healthApi = {
  getScore: (hiveId) => apiClient.get(`/hives/${hiveId}/health-score`).then((r) => r.data),
  triage: () => apiClient.get("/hives/health-triage").then((r) => r.data),
};
